import type { TestProcedureRow } from '#shared/types';

type ProcedureTextKey =
  | 'method'
  | 'specimen'
  | 'container'
  | 'sample_volume'
  | 'storage'
  | 'incubation'
  | 'wavelength'
  | 'temperature'
  | 'principle'
  | 'interferences'
  | 'calculation'
  | 'references';

/** In reading order: the short facts first, then the paragraphs at full width. */
const DETAIL_FIELDS: { key: ProcedureTextKey; label: string; wide?: true }[] = [
  { key: 'method', label: 'Method' },
  { key: 'specimen', label: 'Specimen' },
  { key: 'container', label: 'Container' },
  { key: 'sample_volume', label: 'Sample volume' },
  { key: 'storage', label: 'Storage' },
  { key: 'incubation', label: 'Incubation' },
  { key: 'wavelength', label: 'Wavelength' },
  { key: 'temperature', label: 'Temperature' },
  { key: 'principle', label: 'Principle', wide: true },
  { key: 'interferences', label: 'Interferences', wide: true },
  { key: 'calculation', label: 'Calculation', wide: true },
  { key: 'references', label: 'References', wide: true },
];

interface ProcedureDetail {
  label: string;
  value: string;
  wide?: true;
}

/** The procedure's filled-in fields; a blank one is left out rather than shown as a dash. */
export function procedureDetails(procedure: TestProcedureRow): ProcedureDetail[] {
  return DETAIL_FIELDS.flatMap(({ key, label, wide }) => {
    const text = procedure[key];
    if (!text) return [];
    return wide ? [{ label, value: text, wide }] : [{ label, value: text }];
  });
}
